import { render, staticRenderFns } from "./BonusPointsDetail.vue?vue&type=template&id=029af240&scoped=true&"
import script from "./BonusPointsDetail.vue?vue&type=script&lang=js&"
export * from "./BonusPointsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BonusPointsDetail.vue?vue&type=style&index=0&id=029af240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029af240",
  null
  
)

export default component.exports